<template>
  <div
    v-if="loaded"
    class="c-pdp-hero"
  >
    <div
      v-if="!splitLayout"
      class="c-pdp-hero__container"
      :class="[textSide === 'right' ? 'c-pdp-hero__container--right' : '', heroContainerClass]"
      :style="backgroundImage ? {'background-image':`url(${backgroundImage})`} : {}"
    >
      <div
        class="c-pdp-hero__copy-wrapper"
        :class="[textColorClass]"
      >
        <div
          class="c-pdp-hero__transparent"
          :class="[overlayClass]"
        />
        <div
          id="j-copy-container-height"
          :class="copyContainerClass"
        >
          <div
            id="j-copy-height"
            class="c-pdp-hero__copy"
          >
            <h1
              v-if="title"
              :class="titleClass"
            >
              {{ title }}
            </h1>
            <p
              v-if="subtitle"
              :class="subtitleClass"
            >
              {{ subtitle }}
            </p>
            <wysiwyg
              v-if="description"
              :class="wysiwygClass"
              :html="description"
            />
          </div>
        </div>
      </div>
      <div
        class="c-pdp-hero__empty"
        :class="transparentOverlayType === 'full' ? overlayClass : ''"
      />
    </div>
    <div
      v-else
      class="c-pdp-hero__split-container"
      :class="splitContainerClass"
    >
      <div
        class="c-pdp-hero__split-image"
        :style="{'background-image':`url(${backgroundImage})`}"
      />
      <div
        class="c-pdp-hero__split-copy"
        :class="[overlayClass]"
      >
        <div class="c-pdp-hero__split-copy-container">
          <h1
            v-if="title"
            :class="titleClass"
          >
            {{ title }}
          </h1>
          <p
            v-if="subtitle"
            class="c-hero__subtitle"
            :class="subtitleClass"
          >
            {{ subtitle }}
          </p>
          <wysiwyg
            v-if="description"
            :class="wysiwygClass"
            :html="description"
          />
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <loader />
  </div>
</template>

<script>
import Loader from "../loader/Loader";
import Wysiwyg from "../wysiwyg/Wysiwyg";
import isMobile from '@mixins/isMobile';
import { UrlFilters } from '@mixins/cdnMixins'
export default {
  components: {
    Loader,
    Wysiwyg
  },
  mixins: [
    isMobile,
    UrlFilters
  ],
  props: {
    title: {
      type: String,
      default: '',
    },
    titleTypography: {
      type: String,
      default: 't-heading-7'
    },
    titleMarginBottom: {
      type: String,
      default: 'u-margin-bottom-x-small'
    },
    titleColor: {
      type: String,
      default: 'base',
    },
    subtitle: {
      type: String,
      default: ''
    },
    subtitleTypography: {
      type: String,
      default: 't-heading-7'
    },
    subtitleMarginBottom: {
      type: String,
      default: 'u-margin-bottom-x-small'
    },
    subtitleColor: {
      type: String,
      default: 'base'
    },
    description: {
      type: String,
      default: '',
    },
    descriptionTypography: {
      type: String,
      default: ''
    },
    descriptionMarginBottom: {
      type: String,
      default: 'u-margin-bottom-x-small'
    },
    descriptionColor: {
      type: String,
      default: 'base',
    },
    desktopBackgroundImage: {
      type: Object,
      default: () => ({
        src: '',
        alt: 'desktopBackgroundImage'
      })
    },
    mobileBackgroundImage: {
      type: Object,
      default: () => ({
        src: '',
        alt: 'mobileBackgroundImage'
      })
    },
    transparentOverlayType: {
      type: String,
      default: 'half'
    },
    transparentOverlayColor: {
      type: String,
      default: null
    },
    textSide: {
      type: String,
      default: 'left'
    },
    imageLocation: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isExpandable: false,
      arrowDirection: "right",
    }
  },
  computed: {
    loaded() {
      for (var key in this.$props) {
        if (this.$props[key] !== null) {
          if (this.$props[key]['default'] !== null) {
            return true;
          }
        }
      }
      return false;
    },
    titleClass() {
      let results = [this.titleTypography]
      if (this.subtitle || this.description) {
        results.push("u-margin-bottom-" + this.titleMarginBottom);
      }
      if (this.titleColor) {
        results.push(this.titleTypography + '--' + this.titleColor);
      }
      return results;
    },
    subtitleClass() {
      let results = [this.subtitleTypography];
      if (this.description || this.cta) {
        results.push("u-margin-bottom-" + this.subtitleMarginBottom);
      }
      if (this.subtitleColor) {
        results.push(this.subtitleTypography + '--' + this.subtitleColor);
      }
      return results;
    },
    wysiwygClass() {
      let wysiwygClass = [];
      const marginBottom = this.descriptionMarginBottom
      const descriptionColor = this.descriptionColor
      const descriptionTypography = this.descriptionTypography
      if (marginBottom.length > 0) {
        wysiwygClass.push("u-margin-bottom-" + marginBottom);
      }
      if (descriptionTypography) {
        wysiwygClass.push(descriptionTypography + '--' + descriptionColor);
      }
      else if (descriptionTypography) {
        wysiwygClass.push(descriptionTypography + '--' + descriptionColor);
      }
      return wysiwygClass;
    },
    copyContainerClass() {
      let results = ["c-pdp-hero__copy-container"]
      if (this.isExpandable) {
        results.push("c-pdp-hero__copy-container--expandable")
      }
      return results;
    },
    overlayClass() {
      let result = []
      result.push('u-background-color-' + this.transparentOverlayColor)
      return result
    },
    splitContainerClass() {
      let result = []
      const imageLocation = this.imageLocation
      if(imageLocation == "right") {
        result.push('c-pdp-hero__split-container--right')
      }
      return result
    },
    backgroundImage() {
      let result = {}
      const mobileBackgroundImage = this.mobileBackgroundImage
      const desktopBackgroundImage = this.desktopBackgroundImage
      const isMobile = this.isMobile
      if (isMobile) {
        if (mobileBackgroundImage) {
          result = mobileBackgroundImage.src
        }
      } else {
        if (desktopBackgroundImage) {
          result = desktopBackgroundImage.src
        }
      }
      return this.$getImgUrl(result)
    },
    splitLayout() {
      const imageLocation = this.imageLocation
      let result = false
      if(imageLocation == "left" || imageLocation == "right") {
        result = true
      }
      return result
    }
  },
  created() {
    try {
      window.addEventListener("resize", this.calculateExpandable);
    } catch (err) {
      // console.log('window not loaded');
    }
  },
  mounted() {
    this.calculateExpandable();
  },
  destroyed() {
    try {
      window.removeEventListener("resize", this.calculateExpandable);
    } catch (err) {
      // console.log('window not loaded');
    }
  },
  methods: {
    calculateExpandable() {
      // -30 for padding purposes
      let copyContainerHeight;
      let copyHeight;
      if (document.getElementById('j-copy-container-height')) {
        copyContainerHeight = document.getElementById('j-copy-container-height').clientHeight - 30;
      }
      if (document.getElementById('j-copy-height')) {
        copyHeight = document.getElementById('j-copy-height').clientHeight;
      }

      if (copyHeight > copyContainerHeight) {
        this.isExpandable = true;
      } else {
        this.isExpandable = false;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c-pdp-hero {
  position: relative;
  overflow: hidden;
  &__container {
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: row;
    min-height: 40rem;
    @media screen and (max-width: 900px) {
      flex-direction: column;
    }
    &--right {
      flex-direction: row-reverse;
      justify-content: space-between;
      .c-pdp-hero__transparent {
        right: 0;
      }
      @media screen and (max-width: 900px) {
        flex-direction: column-reverse;
      }
    }
  }
  &__empty {
    width: 50%;
    opacity: 0.3;
    @media screen and (max-width: 900px) {
      width: 100%;
      height: 100px;
    }
  }
  &__copy-wrapper {
    top: 0;
    max-width: 100%;
    display: flex;
    height: auto;
    align-items: center;
    z-index: 1;

    @media screen and (min-width: 901px) {
      max-width: 50%;
    }
  }
  &__copy-container {
    position: relative;
    padding-left: 6vw;
    padding-right: rem(35px);
    display: flex;
    align-items: center;

    &--expandable {
      display: block;
    }
  }
  &__transparent {
    position: absolute;
    width: 50%;
    height: 100%;
    opacity: 0.3;
    overflow: hidden;

    @media screen and (max-width: 900px) {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 100%;
    }
  }
  &__copy-mask {
    position: absolute;
    height: 100%;
    width: 100%;
    background: linear-gradient(to top, white 12%, transparent 60%, transparent);
    z-index: -1;
  }
  &__read-more {
    position: absolute;
    z-index: 1;
    bottom: .5vw;
    text-transform: uppercase;
    @include themify($themes) {
      color: themed('foreground');
    }
  }

  &__expand-button {
    position: absolute;
    z-index: 1;
    right: 0;
    top: 50%;
    transform: translateX(50%) translateY(-50%);
  }
  &__copy {
    position: relative;
    padding: 20px 0;
  }
  &__image-container {
    @include respond(tab-port) {
      height: 400px;
      position: relative;
    }
  }

  &__image {
    width: 100%;
    @include respond(tab-land) {
      height: 100%;
      width: auto;

    }
    @include respond(tab-port) {
      height: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  &__split {
    &-container {
      display: grid;
      grid-template-areas: "image copy";
      grid-template-columns: 1fr 1fr;
      grid-row: auto;
      &--right {
        grid-template-areas: "copy image";
      }
      @include respond(phone) {
        grid-template-areas: "image" "copy";
        grid-template-columns: 1fr;
      }
      @include respond(tab-port) {
        grid-template-areas: "image" "copy";
        grid-template-columns: 1fr;
      }
    }
    &-image {
      grid-area: image;
      height: auto;
      width: 100%;
      min-height: rem(400px);
      background-size: cover;
      background-repeat: no-repeat;
      background-position-x: center;
    }
    &-copy {
      grid-area: copy;
      padding: rem(50px) rem(50px);
      @include respond(phone) {
        padding: rem(10px) rem(10px);
      }
      @include respond(tab-port) {
        padding: rem(10px) rem(10px);
      }
      min-height: rem(400px);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &-container {
        max-width: rem(710px);
      }
    }
  }
}
</style>
